// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserPopoverItem__name-eb2a40 {
  text-overflow: ellipsis;
  overflow: hidden;
  margin-top: 2px;
  color: var(--addition-50);
  font: var(--font-caption-4);
  white-space: nowrap;
}

.UserPopoverItem__name-eb2a40.UserPopoverItem__interact-f10ffc {
  cursor: pointer;
  opacity: 0.9;
}

.UserPopoverItem__name-eb2a40.UserPopoverItem__interact-f10ffc:hover {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/UsersPopover/UserPopoverItem/UserPopoverItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;AACF;;AAEA;EACE,UAAA;AACF","sourcesContent":[".name {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  margin-top: 2px;\n  color: var(--addition-50);\n  font: var(--font-caption-4);\n  white-space: nowrap;\n}\n\n.name.interact {\n  cursor: pointer;\n  opacity: 0.9;\n}\n\n.name.interact:hover {\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"name": `UserPopoverItem__name-eb2a40`,
	"interact": `UserPopoverItem__interact-f10ffc`
};
module.exports = ___CSS_LOADER_EXPORT___;
